export default __webpack_public_path__ + "static/media/greenTick.252b7d45.svg";